var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"profile"},[(!_vm.isLoggedIn)?_c('div',{attrs:{"id":"piano-login-form"}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":_vm.containerSelector}})])
}
var staticRenderFns = []

export { render, staticRenderFns }